module.exports = __webpack_public_path__ + "de1cd22540aa213e98936789b1bde41a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2108_teaser_image.jpg
// module id = 602
// module chunks = 0